import { useCallback, useEffect, useRef, useState } from 'react';

export type BoxShadowProps = { width: number; height: number };

const useScrollableBoxShadow = () => {
  const [scrolling, setScrolling] = useState<boolean>(false);
  const [boxShadowSize, setBoxShadowSize] = useState<BoxShadowProps>({ width: 0, height: 0 });

  const tableRef = useRef<HTMLTableElement>(null);
  const scrollContentRef = useRef<HTMLTableSectionElement>(null);
  const headerRef = useRef<HTMLTableCellElement>(null);

  const handleResize = () => {
    if (headerRef.current && tableRef.current) {
      const width = headerRef.current.getBoundingClientRect().width;
      const height = tableRef.current.clientHeight;
      setBoxShadowSize({ width, height });
    }
  };

  const handleScroll = useCallback(() => {
    if (scrollContentRef.current && tableRef.current) {
      const left = scrollContentRef.current.getBoundingClientRect().left;
      const tableLeft = tableRef.current.getBoundingClientRect().left;
      setScrolling(left < tableLeft);
    }
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setScrolling, scrollContentRef.current, tableRef.current]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    handleResize();
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerRef.current, tableRef.current]);

  return { tableRef, scrollContentRef, headerRef, scrolling, handleScroll, boxShadowSize };
};

export default useScrollableBoxShadow;
